import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Text } from '@hub-la/design-system';
import { useTranslation } from 'react-i18next';

const AccountVerificationHeader = () => {
  const {
    t
  } = useTranslation();
  return jsxs(Stack, Object.assign({
    direction: "column",
    spacing: 3
  }, {
    children: [jsx(Text, Object.assign({
      variant: "h3"
    }, {
      children: t('accountVerification.form.title')
    })), jsx(Text, {
      children: t('accountVerification.form.subtitle')
    })]
  }));
};

export { AccountVerificationHeader };
